/*eslint @typescript-eslint/ban-types: "off" */

import React from 'react';
import DocumentListItem from './DocumentListItem';
import { IDocumentView } from 'store/companies/companiesTypes';

interface IRolesListProps {
  documents: IDocumentView[];
  deleteDocument: (type: string, companyId: number) => void;
  companyId: number;
}

const DocumentList: React.FC<IRolesListProps> = ({
  documents,
  deleteDocument,
  companyId,
}) => {
  return (
    <>
      {Object.values(documents).map((document, index) => (
        <DocumentListItem
          key={index}
          document={document}
          deleteDocument={deleteDocument}
          companyId={companyId}
        />
      ))}
    </>
  );
};

export default DocumentList;
